import HttpClient from "@api/clients/httpClient";
import { Options, Paging, Sorting } from "@api/models/HttpClientModels";
import AdministrationRestaurant from "@components/administration/restaurant/models/Restaurant";
import Restaurant from "@components/restaurant/models/Restaurant";
import RestaurantFilter from "../models/RestaurantFilter";

const config = {
    endpoint: "restaurants",
};

export default class RestaurantService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new RestaurantFilter());
    }

    findAsync = async (filter: RestaurantFilter, sorting: Sorting, paging: Paging, options: Options, optionalUrl?: string) => {
        return await this.httpClient.findAsync<AdministrationRestaurant[]>(filter, paging, sorting, options, optionalUrl);
    };

    getAsync = async (restaurantId: string) => {
        return await this.httpClient.getAsync<Restaurant>(restaurantId, {});
    }

    updateAsync = async (restaurantId: string, restaurant: AdministrationRestaurant) => {
        return await this.httpClient.putAsync(restaurantId, restaurant);
    };

}